import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((error) => error);
};
Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'login',
			alias: '/login',
			component: require('../views/Login/Login.vue').default,
			children: [
				{
					path: '/login/otp',
					name: 'login_otp',
					meta: { next: true },
				}
			]
		},
		{
			path: '/register',
			name: 'register',
			component: require('../views/Register/Register.vue').default,
			meta: { next: true },
			children: [
				{
					path: '/register/otp',
					name: 'register_otp',
					meta: { next: true },
				}
			]
		},
		{
			path: '/forgetPwd',
			name: 'forgetPwd',
			component: require('../views/ForgetPassword/ForgetPassword.vue').default,
			meta: { next: true },
		},
		{
			path: '/resetPwd',
			name: 'resetPwd',
			component: require('../views/ResetPassword/ResetPassword.vue').default,
			meta: { next: true },
		},
		{
			path: '',
			name: 'auth',
			component: require('../views/Auth.vue').default,
			children: [
				{
					path: '/index',
					name: 'index',
					component: require('../views/Index.vue').default,
					children: [
						{
							path: '/channel',
							name: 'channel',
							component: require('../views/Channel/Channel.vue').default,
						},
						{
							path: '/channel/room/:channelID',
							name: 'channel_room',
							component: require('../views/Channel/Room.vue').default,
							children: [
								{
									path: '/channel/room/member/:channelID',
									name: 'channel_room_member',
									component: require('../views/Channel/Member.vue').default
								},
								{
									path: '/channel/room/setting/:channelID',
									name: 'channel_room_setting',
									component: require('../views/Channel/Setting.vue').default
								}
							]
						},
						{
							path: '/notification',
							name: 'notification',
							component: require('../views/Notification.vue').default,
						},
						{
							path: '/setting',
							name: 'setting',
							component: require('../views/Setting/Setting.vue').default,
							children: [
								{
									path: '/setting/edit',
									name: 'setting_edit',
									component: require('../views/Setting/components/Edit.vue').default
								},
								{
									path: '/setting/changePassword',
									name: 'setting_changePassword',
									component: require('../views/Setting/components/ChangePassword.vue').default,
									children: [
										{
											path: '/setting/forgetPassword',
											name: 'setting_forgetPassword',
											component: require('../views/Setting/components/ForgetPassword.vue').default
										}
									]
								},
								{
									path: '/setting/deleteAccount',
									name: 'setting_deleteAccount',
									component: require('../views/Setting/components/DeleteAccount.vue').default
								},
							]
						}
					]
				}
			]
		},
		//使用條款
		{
			path: '/terms',
			name: 'terms',
			component: require('../views/Terms.vue').default,
			meta: { next: true },
		},
		//隱私權
		{
			path: '/privacy',
			name: 'privacy',
			component: require('../views/Privacy.vue').default,
			meta: { next: true },
		}
	]
});

router.beforeEach((to, from, next) => {
	let localStorageCache = localStorage.getItem('VUEX_CACHE');

	if (localStorageCache) {
		localStorageCache = JSON.parse(localStorageCache);

		store.commit('cache/SET_TOKEN', localStorageCache?.token);
		store.commit('cache/SET_REFRESH_TOKEN', localStorageCache?.refreshToken);
		store.commit('cache/SET_REFRESH_TOKEN_ID', localStorageCache?.refreshTokenID);
		store.commit('cache/SET_TOKEN_EXPIRATION_TIME', localStorageCache?.tokenExpirationTime);
	}

	// 登入狀態檢查
	if (store.state.isLogin && to.name === 'login') {
		return next({ path: '/index' });
	}

	// 未登入狀態檢查
	if (!store.state.isLogin && !['login', 'login_otp', 'register', 'register_otp', 'forgetPwd', 'resetPwd'].includes(to.name)) {
		return next({ path: '/login' });
	}

	// 檢查路徑是否在路由配置中
	if (to.matched.length === 0) {
		return next({ path: '/index' });
	}

	// 特殊路由處理
	if (to.meta?.next) {
		return next();
	}

	next();
});

export default router;